import { fetchApi } from '../client';

export type TeleconsultStatus = 'CREATED' | 'ACTIVE' | 'ENDED';

export interface TeleconsultSession {
  sessionId: string;
  roomName: string;
  patientJoinUrl: string;
  doctorJoinUrl: string;
  status: TeleconsultStatus;
}

export interface TeleconsultSessionCheck {
  exists: boolean;
  sessionId?: string;
  roomName?: string;
  patientJoinUrl?: string;
  doctorJoinUrl?: string;
  status?: TeleconsultStatus;
}

export const teleconsultModule = {
  getSession: (tokenId: string) =>
    fetchApi<TeleconsultSessionCheck>(`/api/teleconsult/token/${tokenId}`),

  startSession: (tokenId: string, body?: { doctorId?: string; patientId?: string; teleconsultType?: string }) =>
    fetchApi<TeleconsultSession>(`/api/teleconsult/token/${tokenId}/start`, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined,
    }),

  endSession: (tokenId: string) =>
    fetchApi<{ status: string; endedAt: string | null }>(`/api/teleconsult/token/${tokenId}/end`, {
      method: 'POST',
    }),
};
